import createAsyncSlice from "../utils/createAsyncSlice";
import { getLocalStorage } from "../utils/localStorage";

const auth = createAsyncSlice({
  name: "auth",
  initialState: {
    data: {
      ...getLocalStorage("_tokens", null, true),
      validUserEmail: '',
    },
  },
  reducers: {
    getRefreshToken(state) {
      state.data = {
        ...state.data,
        ...getLocalStorage("_tokens", null, true)
      };
    },

    setValidUserEmail(state, action){
      state.data.validUserEmail = action.payload
    },
  },
});

export const fetchToken = auth.asyncAction;
export const authHttpRequest = auth.httpRequest;
export const { resetState: resetTokenState, getRefreshToken, setValidUserEmail, setIsUserEmailAuthenticated } = auth.actions;
export default auth.reducer;
